import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import MunicipalityHeader from 'components/MunicipalityHeader.jsx';
import NavN1 from 'components/NavN1.jsx'
import Layout from 'components/Layout.jsx';

class MunicipalityLanding extends Component {
  render() {
    return (
      <Layout contentType="destinos" queryTerm={this.props.match.params.slug} lang={this.props.match.params.lang}>
        <div className="content-lvl-1">
          <MunicipalityHeader contentType="destinos" queryTerm={this.props.match.params.slug} lang={this.props.match.params.lang}/>
          <NavN1 contentType="destinos" queryTerm={this.props.match.params.slug} lang={this.props.match.params.lang}></NavN1>
        </div>
      </Layout>);
  }
}

MunicipalityLanding.propTypes = {
  classes: PropTypes.object.isRequired
};

export default translate()(MunicipalityLanding);



// WEBPACK FOOTER //
// ./src/pages/MunicipalityLanding.js